import { PAYMENT_METHOD_HASH_TYPE_TOKENEX } from '../../constants';
import { createLogLocal } from '../../utils/log-local';

const log = createLogLocal('tokenexPaymentMethodHashPayloadFactory.ts');

export const tokenexPaymentMethodHashPayloadFactory = (paymentData: any) => {
  const [expMonth, expYear] = paymentData.cardExpire?.split('/') || [];
  log(`expMonth: ${expMonth}, expYear: ${expYear}`);
  log(`paymentData:`, paymentData);

  const cardholderName =
    paymentData.cardholderName ||
    `${paymentData.firstName} ${paymentData.lastName}`.trim();
  log(`cardholderName:`, cardholderName);

  return {
    type: 'card',
    card: {
      type: PAYMENT_METHOD_HASH_TYPE_TOKENEX,
      [PAYMENT_METHOD_HASH_TYPE_TOKENEX]: {
        token: paymentData.cardNumber.token,
        cvvToken: paymentData.cvv.token,
        cardholderName,
        expMonth,
        // Millenials of the next century - be prepared! :)
        expYear: `20${expYear}`,
      },
    },
    billing_details: {
      name: cardholderName || '',
      email: paymentData.billingEmail || '',
      address1: paymentData.billingAddress1 || '',
      address2: paymentData.billingAddress2 || '',
      city: paymentData.billingCity || '',
      state: paymentData.billingState || '',
      zip: paymentData.billingZip || '',
      country: paymentData.billingCountry || '',
      // 'document' key is BE tech debt, but we support it, as well as "real" (newer) document related fields.
      document: paymentData.billingDocumentNumber || '',
      documentNumber: paymentData.billingDocumentNumber || '',
      documentType: paymentData.billingDocumentType || '',
    },
  };
};
